import { createContext, useCallback, useContext } from 'react';
import useApiService from './ApiService';
import CONFIG from './CONFIG';

const ApiKeyApiContext = createContext(null);

export function ApiKeyApiProvider({ children }) {
  const { get, post, put, del } = useApiService(CONFIG.SERVER_ORGANIZATION);

  const getApiKeys = useCallback(
    async (organizationId, skip, limit) => {
      if (!skip) {
        skip = 0;
      }
      if (!limit) {
        limit = 100;
      }
      try {
        const response = await get(`/v1/api-keys?skip=${skip}&limit=${limit}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching API keys:', error);
        throw error;
      }
    },
    [get],
  );

  const getApiKeyById = useCallback(
    async (apiKeyId) => {
      try {
        const response = await get(`/v1/api-keys/${apiKeyId}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching API key by ID:', error);
        throw error;
      }
    },
    [get],
  );

  const createApiKey = useCallback(
    async (apiKeyData) => {
      try {
        const response = await post(`/v1/api-keys`, apiKeyData);
        return response.data;
      } catch (error) {
        console.error('Error creating API key:', error);
        throw error;
      }
    },
    [post],
  );

  const updateApiKey = useCallback(
    async (apiKeyId, apiKeyData) => {
      try {
        const response = await put(`/v1/api-keys/${apiKeyId}`, apiKeyData);
        return response.data;
      } catch (error) {
        console.error('Error updating API key:', error);
        throw error;
      }
    },
    [put],
  );

  const deleteApiKey = useCallback(
    async (apiKeyId) => {
      try {
        await del(`/v1/api-keys/${apiKeyId}`);
      } catch (error) {
        console.error('Error deleting API key:', error);
        throw error;
      }
    },
    [del],
  );
  return (
    <ApiKeyApiContext.Provider
      value={{
        getApiKeys,
        getApiKeyById,
        createApiKey,
        updateApiKey,
        deleteApiKey,
      }}
    >
      {children}
    </ApiKeyApiContext.Provider>
  );
}

export function useApiKeyApi() {
  const context = useContext(ApiKeyApiContext);
  if (!context) {
    throw new Error('useApiKeyApi must be used within an ApiKeyApiProvider');
  }
  return context;
}
